module.exports = __webpack_public_path__ + "static/img/1-1.80224f6.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/1-1.png
// module id = oOX5
// module chunks = 0